// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ekho","controls":"styles_controls__1DE-g","charLimit":"styles_charLimit__8rYRp","input":"styles_input__coR-D","send":"styles_send__3qffk"};